<mat-form-field class="loren-form-field">
  <mat-label>{{ field.label | transloco : field.labelOptions }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [max]="maxDate.toDate()"
    [value]="field.value"
    (dateChange)="handleFormFieldInteraction($event, field)"
  />
  <mat-datepicker-toggle
    matSuffix
    class="date_container"
    [for]="picker"
  ></mat-datepicker-toggle>
  <mat-datepicker [touchUi]="isHandset" #picker></mat-datepicker>
</mat-form-field>
